import { useLocation, useFetcher, useParams } from 'react-router-dom';
import { styled } from 'styled-components';
import { Dialog, DialogActions } from 'components/ui';

const FormLabel = styled.label`
  font-size: 14px;
  margin-bottom: 6px;
`;

const FormControl = styled.input`
  appearance: none;
  background: #fff;
  border: none;
  border-radius: 2px;
  box-shadow:
    0 0 0 0 rgb(45 114 210 / 0%),
    0 0 0 0 rgb(45 114 210 / 0%),
    inset 0 0 0 1px rgb(17 20 24 / 20%),
    inset 0 1px 1px rgb(17 20 24 / 50%);
  color: #1c2127;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  height: 30px;
  line-height: 30px;
  outline: none;
  padding: 0 8px;
  transition: box-shadow 100ms cubic-bezier(0.4, 1, 0.75, 0.9);
  vertical-align: middle;

  &::placeholder {
    color: #5f6b7c;
    opacity: 1;
  }

  &:focus {
    box-shadow:
      inset 0 0 0 1px #2d72d2,
      0 0 0 2px rgb(45 114 210 / 30%),
      inset 0 1px 1px rgb(17 20 24 / 20%);
  }
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: none;
  padding: 0 15px;
  font-size: 14px;
  line-height: 1;
  font-weight: 500;
  height: 35px;
  cursor: pointer;
  box-shadow:
    inset 0 0 0 1px rgb(17 20 24 / 20%),
    0 1px 2px rgb(17 20 24 / 10%);
  background-color: '#f6f7f9';
  color: '#1c2127';

  &:hover {
    background-color: '#e8e9eb';
  }
`;

const PrimaryButton = styled(Button)`
  background-color: #137cbd;
  color: white;

  &:hover {
    background-color: #0d5da3;
  }
`;

/**
 * EditDashboard component
 *
 * @param {object} props -
 * @param {Function} props.onClose - The function to change the open state of the dialog
 * @param {object} props.dashboard - The dashboard object
 * @returns {JSX.Element} - The EditDashboard component
 */
export default function EditDashboard({ onClose, dashboard }) {
  const { Form } = useFetcher();
  const { pathname } = useLocation();
  const { orgKey } = useParams();
  return dashboard ? (
    <Dialog
      name="Edit Dashboard"
      description="Update the name of an existing dashboard"
      open
      onOpenChange={onClose}
    >
      <Form
        onSubmit={onClose}
        method="put"
        action={`/organization/${orgKey}/dashboard/${dashboard.id}/manage`}
      >
        <FormLabel htmlFor="name">Rename the dashboard</FormLabel>
        <FormControl id="name" name="name" defaultValue={dashboard.name} />
        <FormControl name="returnTo" defaultValue={pathname} type="hidden" />
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <PrimaryButton type="submit">Save</PrimaryButton>
        </DialogActions>
      </Form>
    </Dialog>
  ) : null;
}
